import { createElement, Fragment } from 'react';
// cjs module
import { default as unified } from 'unified';
import remarkParse from 'remark-parse';
import remark2rehype from 'remark-rehype';
// If you need to support HTML tags, remember to sanitize the output
// https://github.com/remarkjs/remark-rehype#example-supporting-html-in-markdown-properly
import rehypeSanitize from 'rehype-sanitize';
import rehypeReact from 'rehype-react';
import { replaceTypeformEnquiryUrl } from '../../util/enquiryLink';

// Content articles can also contain the old enquiry URL in Markdown links.
const replaceEnquiryLinks = () => tree => {
  const visit = node => {
    if (node.tagName === 'a' && node.properties) {
      node.properties.href = replaceTypeformEnquiryUrl(node.properties.href);
    }
    if (node.children) node.children.forEach(visit);
  };
  visit(tree);
};

const processor = (components = {}) => {
  return unified()
    .use(remarkParse)
    .use(remark2rehype)
    .use(rehypeSanitize)
    .use(replaceEnquiryLinks)
    .use(rehypeReact, {
      createElement,
      Fragment,
      components,
    });
};

const renderMarkdown = (markdownText, components) => {
  return processor(components).processSync(markdownText).result;
};
export default renderMarkdown;
